import dayjs from "dayjs";

export const TIME_OFF_STATUS = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
};

export const drivers = [
  {
    id: 1,
    name: "Moses Sambaza",
    schedule: [
      {
        date: dayjs().startOf("week"),
        trips: 0,
        sessions: 0,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(1, "day"),
        trips: 0,
        sessions: 0,
        pending: 0,
        timeoff: 1,
      },
      {
        date: dayjs().startOf("week").add(2, "day"),
        trips: 0,
        sessions: 2,
        pending: 1,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(3, "day"),
        trips: 2,
        sessions: 2,
        pending: 0,
        timeoff: 0,
      },
    ],
  },
  {
    id: 2,
    name: "Jared Machora",
    schedule: [
      {
        date: dayjs().startOf("week"),
        trips: 0,
        sessions: 0,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(1, "day"),
        trips: 0,
        sessions: 0,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(2, "day"),
        trips: 0,
        sessions: 2,
        pending: 1,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(3, "day"),
        trips: 2,
        sessions: 2,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(4, "day"),
        trips: 0,
        sessions: 0,
        pending: 0,
        timeoff: 1,
      },
    ],
  },
  {
    id: 3,
    name: "Jack M",
    schedule: [
      {
        date: dayjs().startOf("week"),
        trips: 0,
        sessions: 0,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(1, "day"),
        trips: 0,
        sessions: 0,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(2, "day"),
        trips: 4,
        sessions: 0,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(3, "day"),
        trips: 4,
        sessions: 0,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(4, "day"),
        trips: 4,
        sessions: 0,
        pending: 0,
        timeoff: 0,
      },
    ],
  },
  {
    id: 4,
    name: "Jill S",
    schedule: [
      {
        date: dayjs().startOf("week"),
        trips: 0,
        sessions: 0,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(1, "day"),
        trips: 0,
        sessions: 0,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(2, "day"),
        trips: 0,
        sessions: 0,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(3, "day"),
        trips: 4,
        sessions: 2,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(4, "day"),
        trips: 0,
        sessions: 4,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(5, "day"),
        trips: 0,
        sessions: 0,
        pending: 1,
        timeoff: 0,
      },
    ],
  },
  {
    id: 5,
    name: "Felix Om",
    schedule: [
      {
        date: dayjs().startOf("week"),
        trips: 0,
        sessions: 0,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(1, "day"),
        trips: 0,
        sessions: 0,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(2, "day"),
        trips: 4,
        sessions: 0,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(3, "day"),
        trips: 0,
        sessions: 2,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(4, "day"),
        trips: 0,
        sessions: 4,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(5, "day"),
        trips: 3,
        sessions: 0,
        pending: 1,
        timeoff: 0,
      },
    ],
  },
  {
    id: 6,
    name: "Eric ER",
    schedule: [
      {
        date: dayjs().startOf("week"),
        trips: 0,
        sessions: 0,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(1, "day"),
        trips: 2,
        sessions: 0,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(2, "day"),
        trips: 2,
        sessions: 2,
        pending: 0,
        timeoff: 0,
      },
      {
        date: dayjs().startOf("week").add(3, "day"),
        trips: 0,
        sessions: 2,
        pending: 0,
        timeoff: 0,
      },
    ],
  },
];
